import React from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import { ServiceGroupDescription } from './ServiceGroupDescription';
import { SERVICE_GROUP_ID } from '@/constants';

const EmbaAdminDashboardEndDateDescription = styled.div`
  color: red;
`;

type SsoLinkDescriptionProps = {
  serviceGroupId: number;
  label: string;
};

export const SsoLinkDescription: React.FC<SsoLinkDescriptionProps> = ({
  serviceGroupId,
  label,
}) => {
  switch (serviceGroupId) {
    case SERVICE_GROUP_ID.hodai:
      return (
        <ServiceGroupDescription>
          <Trans i18nKey="ui.button.expression.admin_dashboard_for_hodai" />
        </ServiceGroupDescription>
      );
    case SERVICE_GROUP_ID.gu:
      return (
        <ServiceGroupDescription>
          <Trans i18nKey="ui.button.expression.admin_dashboard_for_gu"></Trans>
        </ServiceGroupDescription>
      );
    case SERVICE_GROUP_ID.hodaiplus:
      if (label.includes('学び放題')) {
        return (
          <ServiceGroupDescription>
            <Trans i18nKey="ui.button.expression.admin_dashboard_for_plus" />
          </ServiceGroupDescription>
        );
      } else if (label.includes('eMBA2')) {
        return (
          <ServiceGroupDescription>
            <Trans i18nKey="ui.button.expression.emba_admin_dashboard_for_plus" />
            <EmbaAdminDashboardEndDateDescription>
              <Trans i18nKey="ui.button.expression.emba_admin_dashboard_available_until" />
            </EmbaAdminDashboardEndDateDescription>
          </ServiceGroupDescription>
        );
      }
      return null;
    case SERVICE_GROUP_ID.newhodaiplus:
      if (label.includes('学び放題')) {
        return (
          <ServiceGroupDescription>
            <Trans i18nKey="ui.button.expression.admin_dashboard_for_new_plus" />
          </ServiceGroupDescription>
        );
      } else if (label.includes('eMBA')) {
        return (
          <ServiceGroupDescription>
            <Trans i18nKey="ui.button.expression.emba_admin_dashboard_for_new_plus" />
          </ServiceGroupDescription>
        );
      }
      return null;
    case SERVICE_GROUP_ID.newemba:
      return (
        <ServiceGroupDescription>
          <Trans i18nKey="ui.button.expression.admin_dashboard_for_emba" />
        </ServiceGroupDescription>
      );
    default:
      return null;
  }
};
